// extracted by mini-css-extract-plugin
export default {"block":"block--FUL3k","title":"title--S9Vv8","switch-wrapper":"switch-wrapper--u3b8N"};